
export default class TransportationPermissionExtra {
  id: number;
  name: string;
  price: number;
  extraId?: number;
  vatPercentage?: number;
  passengerTransportationPermissionId: number;
}
